var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cz2__lashes",attrs:{"role":"group","aria-labelledby":"lashesHeading"}},[_c('h2',{staticClass:"cz2__lashes-heading",class:{ 'outta-stock': _vm.hasOutOfStock },attrs:{"id":"lashesHeading"}},[_vm._v(" "+_vm._s(_vm.$t('STEP_HEAD'))+" ")]),_c('button',{staticClass:"cz2__switch-button",class:[
            {
                'has-lashes': _vm.hasLashes,
                'no-lashes': !_vm.hasLashes,
                'has-out-of-stock': _vm.hasOutOfStock,
            },
        ],attrs:{"type":"button","role":"switch","disabled":_vm.hasOutOfStock,"aria-checked":_vm.hasLashes},on:{"click":_vm.toggleLashes}},[_c('span',{staticClass:"cz2__switch-button-indicator"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }